<template>
  <div class="ide-mod">
    <!-- Sub-nav lateral -->
    <div class="ide-subnav">
      <button v-for="sec in secciones" :key="sec.id" class="ide-sn-btn" :class="seccion === sec.id ? 'ide-sn-btn--o' : ''" @click="seccion = sec.id" style="transition:0.15s;">
        <span style="font-size:18px; line-height:1; display:flex;">{{ sec.icono }}</span>
        <div style="text-align:left;">
          <div style="font-size:12px; font-weight:600;">{{ sec.label }}</div>
          <div style="font-size:10px; color:var(--text-faint);">{{ sec.desc }}</div>
        </div>
      </button>
    </div>

    <!-- Contenido -->
    <div class="ide-body">
      <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:20px;">
        <div>
          <h2 style="font-size:18px; font-weight:800; color:var(--text-heading); margin-bottom:4px;">{{ sucursal?.nombre }}</h2>
          <p style="font-size:12px; color:var(--text-faint);">{{ sucursal?.codigo }} • {{ sucursal?.direccion }}</p>
        </div>
        <router-link :to="{ name: 'sucursales' }" style="background:none; border:1px solid var(--border); border-radius:6px; padding:8px 12px; cursor:pointer; color:var(--text-muted); font-size:12px; font-family:inherit; text-decoration:none;">
          ← Volver
        </router-link>
      </div>

      <!-- Comandas -->
      <template v-if="seccion === 'comandas'">
        <div style="display:grid; grid-template-columns:repeat(auto-fit, minmax(150px, 1fr)); gap:10px; margin-bottom:20px;">
          <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
            <div style="font-size:18px; font-weight:900; color:#f59e0b; line-height:1;">{{ pendientes }}</div>
            <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Pendientes</div>
          </div>
          <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
            <div style="font-size:18px; font-weight:900; color:#818cf8; line-height:1;">{{ enPrep }}</div>
            <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">En prep.</div>
          </div>
          <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
            <div style="font-size:18px; font-weight:900; color:#22c55e; line-height:1;">{{ listos }}</div>
            <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Listos</div>
          </div>
        </div>
        <div class="ide-ia-card" style="padding:16px;">
          <div v-if="!pedidos.length" style="text-align:center; padding:32px; color:var(--text-disabled);">Sin pedidos hoy</div>
          <div v-else style="display:grid; gap:8px;">
            <div v-for="p in pedidos" :key="p.id" style="border:1px solid var(--border); border-radius:6px; padding:12px; display:flex; justify-content:space-between; align-items:center;">
              <div style="flex:1;">
                <div style="font-weight:600; color:var(--text-heading);">{{ p.codigoPedido }}</div>
                <div style="font-size:11px; color:var(--text-faint);">{{ p.contactoTelefono }} • ${{ Number(p.total).toFixed(2) }}</div>
              </div>
              <div style="display:flex; gap:4px; align-items:center;">
                <span :style="{ background: estadoColor(p.estadoPedido), padding: '4px 8px', borderRadius: '4px', fontSize: '10px', color: 'white', fontWeight: '600' }">
                  {{ estadoLabel(p.estadoPedido) }}
                </span>
                <button @click="abrirCambioEstado(p)" style="background:none; border:1px solid var(--border); cursor:pointer; padding:4px 8px; border-radius:4px; font-size:12px; color:var(--text-muted);">
                  ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- Inventario -->
      <template v-if="seccion === 'inventario'">
        <inventario-sucursal :sucursal-id="sucursalId" :cliente-id="clienteId" />
      </template>

      <!-- Clientes -->
      <template v-if="seccion === 'clientes'">
        <div class="ide-ia-card">
          <div v-if="!clientesLista.length" style="text-align:center; padding:32px; color:var(--text-disabled);">Sin clientes registrados</div>
          <table v-else style="width:100%; border-collapse:collapse; font-size:12px;">
            <thead style="background:var(--bg-alt); border-bottom:1px solid var(--border);">
              <tr>
                <th style="padding:10px 12px; text-align:left; font-weight:600;">Cliente</th>
                <th style="padding:10px 12px; text-align:center; font-weight:600;">Pedidos</th>
                <th style="padding:10px 12px; text-align:center; font-weight:600;">Total gastado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in clientesLista" :key="c.id" style="border-bottom:1px solid var(--border-card);">
                <td style="padding:10px 12px;">
                  <div style="font-weight:600;">{{ c.nombre }}</div>
                  <div style="font-size:10px; color:var(--text-faint);">{{ c.telefono }}</div>
                </td>
                <td style="padding:10px 12px; text-align:center;">{{ c.totalPedidos }}</td>
                <td style="padding:10px 12px; text-align:center; font-weight:600;">${{ Number(c.totalGastado).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- Caja -->
      <template v-if="seccion === 'caja'">
        <caja-sucursal :sucursal-id="sucursalId" :cliente-id="clienteId" />
      </template>
    </div>

    <!-- Modal: Cambio de estado de comanda -->
    <div v-if="dialogCambioEstado" class="cat-overlay" @click.self="dialogCambioEstado = false">
      <div class="cat-modal" style="max-width:350px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">{{ pedidoEdicion?.codigoPedido }}</span>
          <button @click="dialogCambioEstado = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style="padding:18px 22px;">
          <div style="font-size:12px; color:var(--text-faint); margin-bottom:12px;">Estado actual: <strong>{{ estadoLabel(pedidoEdicion?.estadoPedido) }}</strong></div>
          <div style="display:flex; flex-direction:column; gap:8px;">
            <button v-for="sig in estadosSiguientes" :key="sig" @click="cambiarEstado(sig)" style="background:#818cf8; color:white; border:none; border-radius:6px; padding:10px; cursor:pointer; font-family:inherit; font-size:12px; font-weight:600; transition:0.2s;" @mouseover="$event.target.style.background='#6366f1'" @mouseout="$event.target.style.background='#818cf8'">
              → {{ estadoLabel(sig) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InventarioSucursal from './InventarioSucursal.vue'
import CajaSucursal from './CajaSucursal.vue'

export default {
  name: 'SucursalDetalle',
  components: { InventarioSucursal, CajaSucursal },
  data() {
    return {
      seccion: 'comandas',
      sucursal: null,
      pedidos: [],
      clientesLista: [],
      pendientes: 0,
      enPrep: 0,
      listos: 0,
      dialogCambioEstado: false,
      pedidoEdicion: null,
      secciones: [
        { id: 'comandas', label: 'Comandas', desc: 'Flujo de preparación', icono: '📋' },
        { id: 'inventario', label: 'Inventario', desc: 'Stock por sucursal', icono: '📦' },
        { id: 'clientes', label: 'Clientes', desc: 'Clientes finales', icono: '👥' },
        { id: 'caja', label: 'Caja', desc: 'Transacciones', icono: '💰' },
      ],
    }
  },
  computed: {
    sucursalId() {
      return this.$route.params.id || this.$store.getters.sucursalId
    },
    clienteId() {
      return this.$store.getters.clienteId
    },
    estadosSiguientes() {
      const map = {
        'pendiente_confirmacion': ['confirmado', 'cancelado'],
        'confirmado': ['en_preparacion', 'cancelado'],
        'en_preparacion': ['listo', 'cancelado'],
        'listo': ['en_camino', 'cancelado'],
        'en_camino': ['entregado', 'cancelado'],
        'entregado': [],
        'cancelado': [],
      }
      return map[this.pedidoEdicion?.estadoPedido] || []
    },
  },
  watch: {
    seccion() {
      this.cargarSeccion()
    },
  },
  mounted() {
    this.cargarSucursal()
    this.cargarSeccion()
    this.intervalo = setInterval(() => {
      if (this.seccion === 'comandas') this.cargarSeccion()
    }, 30000)
  },
  beforeDestroy() {
    if (this.intervalo) clearInterval(this.intervalo)
  },
  methods: {
    async cargarSucursal() {
      if (!this.clienteId) return
      try {
        this.sucursal = await this.$service.get(`sucursales`, this.sucursalId)
      } catch (err) {
        this.$message.error('Error al cargar sucursal')
      }
    },
    async cargarSeccion() {
      if (!this.clienteId || !this.sucursalId) return
      try {
        if (this.seccion === 'comandas') {
          this.pedidos = await this.$service.list(`sucursales/${this.sucursalId}/pedidos`) || []
          this.pendientes = this.pedidos.filter(p => p.estadoPedido === 'pendiente_confirmacion').length
          this.enPrep = this.pedidos.filter(p => p.estadoPedido === 'en_preparacion').length
          this.listos = this.pedidos.filter(p => p.estadoPedido === 'listo').length
        } else if (this.seccion === 'clientes') {
          this.clientesLista = await this.$service.list(`sucursales/${this.sucursalId}/clientes`) || []
        }
      } catch (err) {
        console.error(err)
      }
    },
    estadoColor(estado) {
      const colores = {
        'pendiente_confirmacion': '#f59e0b',
        'confirmado': '#818cf8',
        'en_preparacion': '#0ea5e9',
        'listo': '#22c55e',
        'en_camino': '#8b5cf6',
        'entregado': '#6366f1',
        'cancelado': '#64748b',
      }
      return colores[estado] || '#64748b'
    },
    estadoLabel(estado) {
      const labels = {
        'pendiente_confirmacion': 'Pendiente',
        'confirmado': 'Confirmado',
        'en_preparacion': 'En prep.',
        'listo': 'Listo',
        'en_camino': 'En camino',
        'entregado': 'Entregado',
        'cancelado': 'Cancelado',
      }
      return labels[estado] || estado
    },
    abrirCambioEstado(pedido) {
      this.pedidoEdicion = pedido
      this.dialogCambioEstado = true
    },
    async cambiarEstado(nuevoEstado) {
      if (!this.pedidoEdicion) return
      try {
        await this.$service.patch(`pedidos/${this.pedidoEdicion.id}/estado`, { estadoPedido: nuevoEstado })
        this.$message.success(`Pedido actualizado a ${this.estadoLabel(nuevoEstado)}`)
        this.dialogCambioEstado = false
        this.cargarSeccion()
      } catch (err) {
        this.$message.error('Error al cambiar estado')
      }
    },
  },
}
</script>

<style scoped>
.ide-mod {
  display: flex;
  gap: 0;
  height: calc(100vh - 80px);
  background: var(--bg);
}

.ide-subnav {
  width: 220px;
  border-right: 1px solid var(--border);
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  background: var(--bg-alt);
}

.ide-sn-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  font-family: inherit;
  text-align: left;
  transition: 0.2s;
  margin: 0 8px;
  border-radius: 6px;
}

.ide-sn-btn:hover {
  background: var(--bg);
  color: var(--text-primary);
}

.ide-sn-btn--o {
  background: var(--bg);
  color: var(--text-heading);
  font-weight: 600;
  border-left: 3px solid #818cf8;
}

.ide-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}
</style>
